module.exports = __webpack_public_path__ + "om.d3eca0fe2f449768d000.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/om.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/om.svg
// module chunks = styles